module.exports = __webpack_public_path__ + "img/img-bisiness-intelligence.1cbccc45.png";